import clsx from "clsx"
import { Nunito } from "next/font/google"

const nunito = Nunito({
  subsets: ["latin"],
  weight: "variable",
  variable: "--font-nunito",
})

export const fontClassName = clsx(nunito.className, nunito.variable)
